module.exports = __webpack_public_path__ + "img/animal_chara_fukurou_hakase.6088e97e.png";